import CommercialBanking from './commercial-banking'
import Bill from './bill'
import BankCredit from './bank-credit'

export default {
  name: 'CommercialBanking',
  path: 'commercial-banking',
  meta: {
    label: 'comercialBanking'
  },
  component: {
    name: 'ComercialBanking',
    render(c) {
      return c('router-view')
    }
  },
  children: [CommercialBanking, Bill, BankCredit]
}
